module.exports = __webpack_public_path__ + "assets/loadable-components.38d83e10.svg";